var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "schedule_detail container"
  }, [_c('h2', {
    staticClass: "text-center fs-40",
    staticStyle: {
      "line-height": "120px"
    }
  }, [_vm._v("展位图")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/zwt/2025/1.jpeg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/zwt/2025/2.jpeg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/zwt/2025/3.jpeg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/zwt/2025/4.jpeg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/zwt/2025/5.jpeg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/zwt/2025/6.jpeg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/zwt/2025/7.jpeg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/zwt/2025/8.jpeg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/zwt/2025/9.jpeg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/zwt/2025/10.jpeg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/zwt/2025/11.jpeg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/zwt/2025/12.jpeg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/zwt/2025/13.jpeg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/zwt/2025/14.jpeg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/zwt/2025/15.jpeg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/zwt/2025/16.jpeg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/zwt/2025/17.jpeg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/zwt/2025/18.jpeg",
      "alt": ""
    }
  })])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0d996da","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/schedule/components/exMap.vue
// module id = null
// module chunks = 